import { Button, styled } from "@mui/material";

export const RegularButton = styled(Button)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  padding: "8px 16px",
  width: "64px",
  height: "40px",
  boxShadow:
    "0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  borderRadius: "6px",
}));
